import { SessionInput } from '@src/types/graphql-types'
import {
  checkForRedesignedBiTubeProduct,
  SingleTubeFormValues,
} from './ProductsConfiguration'

export const getSessionDataFromFormikData = (
  productType,
  formikOligoList: SingleTubeFormValues[],
  isoCode?: boolean,
  useOligoId?: boolean
) => {
  const arr: SessionInput[] = []
  formikOligoList.forEach((item: any, index) => {
    const {
      amount,
      autoGenerateOligo,
      format,
      tubes,
      concentration,
      gcContent,
      purification,
      scale,
      name,
      price,
      currency,
      sequence,
      fiveMod,
      threeMod,
      internalMod,
      fiveModCategory,
      threeModCategory,
      internalModCategory,
      baseCount,
      molecularWeight,
      secondaryStructure,
      primerDimer,
      otherValue,
      isOverridden,
      cartId,
      itemId,
      additionalServices,
      comments,
      flag,
      oligoId,
      probeType,
      antisenseBaseCount,
      antisenceFiveMod,
      antisenceName,
      antisenceSequence,
      antisenceThreeMod,
      customerOverhang,
      customerAntisenseOverHang,
      currencySymbol,
      countryCode,
      senseNameCheck,
    } = item
    checkForRedesignedBiTubeProduct(productType)
      ? arr.push({
          antisenceBaseCount: Number(antisenseBaseCount),
          antisenceName,
          antisenceSequence,
          autoGenerateOligo,
          customerOverhang: customerOverhang || '',
          customerAntisenseOverHang: customerAntisenseOverHang || '',
          antisenceThreeMod,
          antisenceFiveMod,
          id: String(index),
          oligoId: useOligoId ? oligoId : index,
          name,
          sequence,
          baseCount: 14,
          threeMod,
          fiveMod: fiveMod || '',
          format: format || 'DRY',
          purification,
          concentration: concentration || '',
          countryCode,
          productType,
          scale: scale || '',
          price: price || '_',
          tubes: tubes || '1',
          autoValidation: 'false',
          comments: comments || '',
          additionalComments: '',
          applyToAll: null,
          isOverridden,
          orderItemId: '',
          amount,
          senseNameCheck,
          listError: [],
          cartId: cartId || '',
          itemId: itemId || '',
          currencySymbol,
          currency,
        })
      : arr.push({
          additionalCarrierProtein: '',
          additionalComments: '',
          additionalServices: additionalServices,
          amount,
          animalType: '',
          applyToAll: false,
          autoGenerateOligo,
          autoValidation: '',
          baseCount: Number(baseCount),
          carrierProtein: '',
          cartId: cartId || '',
          columnConstruction: '',
          comments: comments || '',
          concentration,
          conjugation: '',
          conjugationAmount: '',
          conjugationChemistry: '',
          countryCode: '',
          crossContamination: '',
          crRnaType: '',
          cterminalMod: '',
          currency: '',
          currencySymbol: '',
          customerAntisenseOverHang: '',
          customerOverhang: '',
          customPeptideType: '',
          elisaAnalysis: '',
          email: '',
          epsilon: 0,
          firstName: '',
          fiveMod,
          fiveModCategory,
          flag: flag || 0,
          format,
          fullSOligoBackbone: false,
          gcContent: String(gcContent),
          id: String(index),
          immunizationTerm: '',
          internalMod,
          internalModCategory,
          isCSR: false,
          isCSRSupervisor: false,
          isLabelledAminoAcid: false,
          isLNABaseEnable: false,
          isoCode: isoCode || false,
          isOverridden,
          itemId: itemId || '',
          lastName: '',
          listAntiseraPeptideModel: [],
          listError: [],
          listProductPackage: [],
          listShippingOptions: [],
          listWarning: [],
          material: '',
          meltingTemparature: '',
          minimumYield: '',
          molecularWeight,
          name,
          noOfColumns: '',
          nterminalMod: '',
          numberOfAnimals: '',
          numberOfPeptides: '',
          oligoId: useOligoId ? oligoId : index,
          orderItemId: '',
          orgName: '',
          otherValue,
          packageType: '',
          peptide: '',
          phone: '',
          plateType: '',
          price: '',
          priceHeaderError: '',
          primerDimer,
          probeType: probeType || 'duallabel',
          productType,
          projectName: '',
          projectType: '',
          purification,
          purificationAntisera: '',
          purificationBuffer: '',
          purificationColQuantity: '',
          purificationColumn: '',
          purificationGlycAddition: '',
          purificationOption: '',
          purificationProcAddition: '',
          purificationType: '',
          purityLevel: '',
          quantitation: '',
          scale,
          secondaryStructure,
          sequence,
          sequenceLocation: '',
          shipping: '',
          threeMod,
          threeModCategory,
          tubes,
        })
  })
  return arr
}
